import { toast, ToastOptions } from 'react-toastify'

const DEDUPE_MS = 4500

/** Normalize so "❌ Same text" and "same text" dedupe together */
function normalizeDedupeKey(message: string): string {
  return message
    .trim()
    .toLowerCase()
    .replace(/[\s\n\r]+/g, ' ')
    .replace(/^[^a-z0-9]+/i, '')
    .slice(0, 160)
}

const lastShownAt = new Map<string, number>()

function shouldSuppressDuplicate(key: string): boolean {
  const now = Date.now()
  const prev = lastShownAt.get(key) ?? 0
  if (now - prev < DEDUPE_MS) return true
  lastShownAt.set(key, now)
  return false
}

const defaultErrorToast: ToastOptions = {
  position: 'top-center',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
}

/**
 * Single entry for error toasts: dedupes same message within a few seconds and
 * uses toastId so React-Toastify merges rapid duplicates instead of stacking.
 */
export function notifyError(message: string, options?: ToastOptions) {
  const text = (message || '').trim()
  if (!text) return

  const key = normalizeDedupeKey(text)
  if (!key) return
  if (shouldSuppressDuplicate(key)) return

  const toastId = `err-${key.slice(0, 96).replace(/\s+/g, '-')}`

  toast.error(text, {
    ...defaultErrorToast,
    toastId,
    ...options,
  })
}
